import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { TipoUnidadeForcaMuscular } from 'graphql/types.generated'
import React from 'react'
import { UNIDADE_FORCA_MUSCULAR } from 'view/atendimentos/detail/components/modals/medicoes/model-medicoes'

export interface UnidadeForcaMuscularSelectModel {
  enum: TipoUnidadeForcaMuscular
  nome: string
  sigla: string
}

type UnidadeForcaMuscularSelectFieldProps = Omit<
  SelectFieldProps<UnidadeForcaMuscularSelectModel>,
  'items' | 'itemToString'
>

const itemToString = (item: UnidadeForcaMuscularSelectModel) => item?.sigla

const renderItem = (item: UnidadeForcaMuscularSelectModel) => item && `${item.nome} (${item.sigla})`

export function UnidadeForcaMuscularSelectField(props: Readonly<UnidadeForcaMuscularSelectFieldProps>) {
  return (
    <SelectField<UnidadeForcaMuscularSelectModel>
      items={items}
      itemToString={itemToString}
      renderItem={renderItem}
      {...props}
    />
  )
}

const items: UnidadeForcaMuscularSelectModel[] = [
  TipoUnidadeForcaMuscular.QUILOGRAMAFORCA,
  TipoUnidadeForcaMuscular.GRAMAFORCA,
  TipoUnidadeForcaMuscular.LIBRAFORCA,
  TipoUnidadeForcaMuscular.NEWTON,
].map(
  (enumValue): UnidadeForcaMuscularSelectModel => {
    const { nome, sigla } = UNIDADE_FORCA_MUSCULAR[enumValue]

    return {
      enum: enumValue,
      nome,
      sigla,
    }
  }
)
